import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmojiU1f4c8IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmojiU1f4c8Icon = ({ className, ...props }: EmojiU1f4c8IconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_262_36126)">
      <path
        d="M21.3125 0.6875H0.6875V21.3125H21.3125V0.6875Z"
        fill="white"
      />
      <path
        d="M4.24536 0.721878V21.2781"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.342564"
      />
      <path
        d="M7.62268 0.721878V21.2781"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.342564"
      />
      <path
        d="M11 0.721878V21.2781"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.342564"
      />
      <path
        d="M14.3776 0.721878V21.2781"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.342564"
      />
      <path
        d="M17.7549 0.721878V21.2781"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.342564"
      />
      <path
        d="M21.2781 4.23843H0.713257"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.2799 7.61923H0.715088"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.2835 11H0.716919"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.2852 14.3808H0.720337"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.2869 17.7616H0.722046"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M0.876543 21.1372L0.862793 20.0784L5.48967 11.7391L9.56311 15.5048L20.5253 0.878281H21.1251L21.1492 1.76516L9.70232 17.038L5.74576 13.3805L1.45232 21.1423L0.876543 21.1372Z"
        fill="#E53935"
      />
      <path
        d="M20.9705 1.02953V20.9688H1.02953V1.02953H20.9705ZM21.3125 0.6875H0.6875V21.3125H21.3125V0.6875Z"
        fill="#B0BEC5"
      />
    </g>
    <defs>
      <clipPath id="clip0_262_36126">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmojiU1f4c8Icon;
